import React, { useState } from "react";
import {
    FormControl,
    Menu,
    MenuItem,
    Button,
    ListItemText,
    ListItemIcon,
} from "@mui/material";

import ArrowRightIcon from "@mui/icons-material/ArrowRight";




export const ColumnFieldSelector = ({
  header,
  mapping,
  onMappingChange,
  modelFields,
}: {
  header: string;
  mapping: Record<string, string>;
  onMappingChange: (header: string, field: string) => void;
  modelFields: any[];
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [submenuAnchor, setSubmenuAnchor] = useState<null | HTMLElement>(null);
  const [activeCategory, setActiveCategory] = useState<string | null>(null);
    
  const handleOpenMenu = (event: any) => setAnchorEl(event.currentTarget);

  const handleOpenSubmenu = (event: any, category: string) => {
    setActiveCategory(category);
    setSubmenuAnchor(event.currentTarget);
  };

  const handleCloseMenus = () => {
    setAnchorEl(null);
    setSubmenuAnchor(null);
    setActiveCategory(null);
  };

  // Compute selected label
  const selectedLabel =
    mapping[header] &&
    modelFields
      .flatMap((group: any) => group.fields || [group])
      .find((f: any) => f.field === mapping[header])?.label;

  return (
    <FormControl fullWidth size="small">
      <Button
        variant="outlined"
        onClick={handleOpenMenu}
        sx={{ justifyContent: "space-between"}}
      >
        {selectedLabel || "Select Field"}
      </Button>

      {/* CATEGORY MENU */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenus}>
        <MenuItem
          onClick={() => {
            onMappingChange(header, "");
            handleCloseMenus();
          }}
        >
          <em>Ignore</em>
        </MenuItem>

        {modelFields.map((group: any) =>
          group.category ? (
            <MenuItem
              key={group.category}
              onClick={(e) => handleOpenSubmenu(e, group.category)}
            >
              <ListItemText primary={group.category} />
              <ListItemIcon sx={{ minWidth: 24 }}>
                <ArrowRightIcon fontSize="small" />
              </ListItemIcon>
            </MenuItem>
          ) : (
            // fallback for flat lists
            <MenuItem
              key={group.field}
              onClick={() => {
                onMappingChange(header, group.field);
                handleCloseMenus();
              }}
            >
              {group.label}
            </MenuItem>
          )
        )}
      </Menu>

      {/* SUBMENU */}
      <Menu
        anchorEl={submenuAnchor}
        open={Boolean(submenuAnchor)}
        onClose={() => setSubmenuAnchor(null)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {activeCategory &&
          modelFields
            .find((g: any) => g.category === activeCategory)
            ?.fields.map((f: any) => (
              <MenuItem
                key={f.field}
                onClick={() => {
                  onMappingChange(header, f.field);
                  handleCloseMenus();
                }}
              >
                {f.label}
              </MenuItem>
            ))}
      </Menu>
    </FormControl>
  );
};

export default ColumnFieldSelector;